import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { TagType } from '../../constants';

type TimeTagProps = {
  type: TagType;
  onClick: (type: TagType, value?: number) => void;
  value?: number;
  selected?: boolean;
};

export const TimeTag = ({ type, value, onClick, selected }: TimeTagProps) => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    onClick(type, value);
  }, [onClick, type, value]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={twMerge(
        'text-primary-300 h-fit w-fit rounded-md border border-gray-300 bg-gray-200  p-1 text-xs font-semibold',
        selected && 'border-blueNuit bg-blueNuit text-white',
      )}
    >
      {t(type, { value })}
    </button>
  );
};
